import { ValueType } from 'realgrid'

export const custFields = [
    {
      fieldName: 'custCd',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'custNm',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'custAddr',
      dataType: ValueType.TEXT
    }
  ]
  
  export const custColumns = [
    {
      name: 'custCd',
      fieldName: 'custCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
        text: '거래처코드',
        showTooltip: false
      },
      visible: true,
      editable: false
    },
    {
      name: 'custNm',
      fieldName: 'custNm',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: '거래처명',
      visible: true,
      editable: false
    },
    {
      name: 'custAddr',
      fieldName: 'custAddr',
      type: 'data',
      width: '500',
      styleName: "rg-align-left",
      header: '거래처주소',
      visible: true,
      editable: false
    }
  ]